<template>
  <div>
    <div style="display: flex; align-items: center; margin-bottom: 8px;">
      <label>分类名：</label>
      <el-input v-model="sortForm.sort" placeholder="请输入分类名" style="flex: 1;"/>
    </div>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >返回</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">提交</el-button>
    </div>
  </div>
</template>

<script>
import {addOrUpdateLoveSubmitSortList} from '../../../api/url'
import {postFormData, getFormData} from "@/api/api";

export default {
  name: "ReportDialog",
  props: {
    value: Object
  },
  data() {
    return {
      sortForm: this.value.sortForm,
      idx: this.value.ids,
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    submit() {
      this.loading = true
      let param = {}
      param['id'] = this.idx > -1?this.sortForm.id:0;
      param['sort'] = this.sortForm.sort;
      postFormData(addOrUpdateLoveSubmitSortList, param).then((data)=>{
        let {code, msg} = data;
        if(code == 200) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm', param)
        }else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    },


  },
  created() {
  }
}
</script>

<style scoped>

</style>
